import axios from 'axios';

export const user = {
	state() {
		return {
			currentUser: null,
		};
	},
	mutations: {
		setCurrentUser(state, data) {
			state.currentUser = data;
		},
	},
	getters: {
		getCurrentUser: (state) => state.currentUser,
	},

	actions: {
		fetchCurrentUser({ commit }) {
			return axios
				.get('user/current-user')
				.then((response) => {
					const data = response.data;
					commit('setCurrentUser', data);
				})

				.catch(() => {})
				.finally(() => {});
		},
	},
};
